import { createSlice } from '@reduxjs/toolkit'

const initialState = []

export const packageSlice = createSlice({
  name: 'package',
  initialState,
  reducers: {
    addPackage(state, action) {
      state.push(action.payload)
    },
    removePackage(state, action) {
      return state.filter(({ name }) => name !== action.payload.name)
    }
  }
})

export const { addPackage, removePackage } = packageSlice.actions

export default packageSlice.reducer
